import request from '@/utils/request'

// 注册
export function register(data) {
    return request({
      url: '/api/register',
      method: 'post',
      data: data
    })
  }
  // 登录
  export function login(data) {
    return request({
      url: '/api/login',
      method: 'post',
      data: data
    })
  }
  //退出登录
  export function logout(){
    return request({
      url: '/api/logout',
      method: 'post'
    })
  }
  //推荐列表
  export function recommendList(){
    return request({
      url: '/api/human/list/recommend',
      method: 'get'
    })
  }
  //数字人列表
  export function humanList(){
    return request({
      url: '/api/human/list',
      method: 'get'
    })
  }
  //设备列表
  export function deviceList(params){
    return request({
      url: '/api/devices',
      method: 'get',
      params
    })
  }
  //绑定数字人形象
  export function bindHuman(data){
    return request({
      url: '/api/device/human/bind',
      method: 'post',
      data
    })
  }
  //绑定设备
  export function bindDeviceApi(data){
    return request({
      url: '/api/device/bind',
      method: 'post',
      data
    })
  }
  //解绑设备
  export function unbindDeviceApi(data){
    return request({
      url: '/api/device/unbind',
      method: 'post',
      data
    })
  }